import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import { Button, Typography } from 'primsell-shared-layer/components'
import { CloseIcon } from 'primsell-shared-layer/assets/icons'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

import { ModalTypeE } from './modal.types'
import { ButtonSizeT } from 'primsell-shared-layer/components/atoms/button/button.types'

const rightTopButtonStyles = css`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
  width: 40px;
  height: 40px;
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(23, 23, 78, 0.37);
  overflow: hidden;
  z-index: 5;
`

export const FullSizeContainer = styled.div`
  max-width: 100%;
  height: 100%;
  padding: 50px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DefaultContainer = styled.div<{ width?: number | string; scrollable?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;

  padding: 32px;

  width: ${({ width }) => (width ? `${width}px` : '488px')};

  background: #f9fafb;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);

  max-height: 95vh;
  overflow-y: hidden;

  ${({ scrollable }) =>
    scrollable &&
    css`
      padding-left: 8px;
      overflow-y: auto;
    `}
`

export const CloseButton = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
`

export const ZoomOutButton = styled(Button)<{ position?: ButtonSizeT }>`
  ${rightTopButtonStyles};

  ${({ position }) =>
    position === 'xxs' &&
    css`
      right: -36px;
      top: -30px;
      padding: 0;
      width: 24px;
      height: 24px;

      svg {
        width: 10px;
        height: 10px;
      }
    `}
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TitleTypography = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  color: ${baseTheme.colors.lightDark};
  text-align: center;
`

const contentTypeConfig: Record<ModalTypeE, FlattenSimpleInterpolation> = {
  [ModalTypeE.DEFAULT]: css`
    gap: 16px;
  `,
  [ModalTypeE.FULL_SIZE]: css`
    position: relative;
    & > img {
      max-height: calc(100vh - 96px);
    }
  `,
}

export const Content = styled.div<{ type?: ModalTypeE }>`
  ${({ type }) => contentTypeConfig[type ?? ModalTypeE.DEFAULT]}

  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 12px;
`

export const Footer = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`
